
<template>
  <div
    @click="setActiveArea(page)"
    :class="[
      'hover:tw-no-underline',
      isSelected ? 'tw-text-[#1F2229]' : 'tw-text-white hover:tw-text-current'
    ]"
  >
    <li
      :class="[
        'tw-flex tw-justify-between tw-items-center',
        'tw-py-2 tw-px-4 tw-rounded-lg',
        'tw-font-poppins tw-text-sm tw-font-medium tw-whitespace-nowrap',
        'tw-cursor-pointer',
        isSelected ? 'tw-bg-white' : 'hover:tw-bg-black hover:tw-bg-opacity-20',
      ]"
    >
      <slot>
        {{ display || autoDisplayName }}
      </slot>
      <i
        v-if="isSelected"
        class="fa fa-arrow-right tw-text-[#F1583D]"
      />
    </li>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'AdvisorCoreNavLink',
  components: { /* Subcomponents */ },
  props: {
    page: { type: String, required: true },
    display: { type: String, default: '' },
  },
  data() {
    return {

    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useCheckupStore),
    targetRouteName() {
      return `AdvisorCore${this.page}`;
    },
    currentRouteName() {
      return this.$route.name;
    },
    isSelected() {
      return this.checkupStore.activeArea === this.page;
    },
    autoDisplayName() {
      // Create a human-friendly display name from the page name, which is PascalCase.
      try {
        // Add a space before each capital letter, then trim extra spaces.
        return this.page.replace(/([A-Z])/g, ' $1').trim();
        //
      } catch (e) {
        return this.page;
      }
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    setActiveArea(area) {
      this.checkupStore.setActiveArea(area);
    },
  },
};
</script>


  <style scoped>

  </style>
